import React, { useEffect, useState } from 'react'
import ContainerDashboard from '../../components/layouts/ContainerDashboard'
import { useNavigate, useParams } from 'react-router-dom';
import { axiosInstance } from '../Config';

const ViewCourse = () => {

    const [title, setTitle] = useState('')
    const [price, setPrice] = useState('')
    const [theorySessons, setTheorySessons] = useState('')
    const [practicalSessons, setPracticalSessons] = useState('')
    const [car_type, setCarType] = useState('')

    const [description, setDescription] = useState(``)

    const [course_image, setCourseImage] = useState('')
    const [course_image_link, setCourseImageLink] = useState('https://images.unsplash.com/photo-1564564321361-5694c96475ec?q=80&w=1476&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate()

    useEffect(() => {
        window.scrollTo(0, 0);
        getcoursedata();
    }, [])

    const { id } = useParams()

    function getcoursedata() {
        setLoading(true)
        axiosInstance.get(`get-cources/${id}`)
            .then(res => {
                setCourseImageLink(res?.data?.cource?.imageUrl)
                setTitle(res?.data?.cource?.title);
                setPrice(res?.data?.cource?.price);
                setTheorySessons(res?.data?.cource?.theory);
                setPracticalSessons(res?.data?.cource?.practical);
                setCarType(res?.data?.cource?.cartype);
                setDescription(res?.data?.cource?.description);
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }

    useEffect(() => {
        document.title = "View Course | Precision Driving"
    }, [])

    return (
        <>
            <ContainerDashboard title="Course Details" description="Everything here">
                <div className="p-4 py-5 bg-gradientt rounded-4">
                    <section className="ps-dashboards" id="homepages">
                        <div className="row justify-content-between align-items-center">
                            <div>
                                <form className="therapist-profile-form">
                                    <div className="row px-md-5">
                                        <div className="col-md-3 px-4 ">
                                        <label className='text-green mb-2'>Course Image  </label>
                                        <img src={course_image_link} alt="" className="border border-2 border-light p-1 " />

                                        </div>
                                    </div>
                                    <div className="row px-md-5 mt-5">
                                        <div className="col-md-8 px-4">
                                            <div className="input-field ">
                                                <label for="name" className='label'>
                                                    <input type="text" id="name" placeholder="Name"
                                                        value={title}
                                                        readOnly
                                                        onKeyPress={(e) => {
                                                            if (/[0-9]/.test(e.key)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        onChange={(e) => setTitle(e.target.value)}
                                                    />
                                                    <span>Course Title </span>
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-md-4 px-4">
                                            <div className="input-field ">
                                                <label for="price" className='label'>
                                                    <input type="text" id="price" placeholder="Name"
                                                        value={price}
                                                        readOnly
                                                        onKeyPress={(e) => {
                                                            if (/[0-9]/.test(e.key)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        onChange={(e) => setPrice(e.target.value)}
                                                    />
                                                    <span>Price in £ </span>
                                                </label>
                                            </div>

                                        </div>

                                        <div className="col-md-4 px-4">
                                            <div className="input-field ">
                                                <label for="theory" className='label'>
                                                    <input type="text" id="theory" placeholder="Name"
                                                        value={theorySessons}
                                                        readOnly
                                                        onKeyPress={(e) => {
                                                            if (/[0-9]/.test(e.key)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        onChange={(e) => setTheorySessons(e.target.value)}
                                                    />
                                                    <span>Theory Session (Hours) </span>
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-md-4 px-4">
                                            <div className="input-field ">
                                                <label for="practical" className='label'>
                                                    <input type="text" id="practical" placeholder="Name"
                                                        value={practicalSessons}
                                                        readOnly
                                                        onKeyPress={(e) => {
                                                            if (/[0-9]/.test(e.key)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        onChange={(e) => setPracticalSessons(e.target.value)}
                                                    />
                                                    <span>Practical Session (Hours) </span>
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-md-4 px-4">
                                            <div className="input-field ">
                                                <label htmlFor="cartype" className='label'>
                                                    <select id="cartype"
                                                        disabled
                                                        value={car_type}
                                                        onChange={(e) => setCarType(e.target.value)}
                                                    >
                                                        <option value=""> Select Car Type</option>
                                                        <option value="Manual">Manual</option>
                                                        <option value="Automatic">Automatic</option>
                                                    </select>
                                                    <span>Car Type </span>
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-12 px-4 mt-4 ">
                                            <label htmlFor="" className='text-green ps-3 mb-1'>
                                                Add more details about this course </label>
                                            <textarea
                                                value={description}
                                                readOnly
                                                rows={7}
                                                onChange={(e) => setDescription(e.target.value)}
                                                placeholder="Describe here.."
                                                className=' text-area-input p-3'
                                            >

                                            </textarea>
                                        </div>

                                        <div className="col-12 text-center mt-5">
                                            <button type="button" onClick={() => navigate(-1)}
                                                className="button btn-black text-white me-4">
                                                <i className='icon-arrow-left me-3 fs-5'></i>
                                                back</button>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </section>
                </div>
            </ContainerDashboard>
        </>
    )
}

export default ViewCourse